const CLIENT_ID_STORAGE_KEY = "school_leader_ai_lab_client_id";

const generateClientId = () => {
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    const bytes = new Uint8Array(12);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getOrCreateClientId = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const existing = window.localStorage.getItem(CLIENT_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }

  const created = generateClientId();
  window.localStorage.setItem(CLIENT_ID_STORAGE_KEY, created);
  return created;
};
